@if (loading()) {
    <section class="flex! justify-between! items-center! pb-6">
        <div class="flex! flex-col gap-2 w-full">
            <p-skeleton width="14rem" height="2rem" />
            <p-skeleton width="20rem" height="1.25rem" />
        </div>
        <p-skeleton width="24rem" height="3rem" borderRadius="8px" />
    </section>

    <section class="w-full flex! flex-wrap! gap-4! pb-6">
        @for (i of [1, 2, 3, 4]; track i) {
            <p-skeleton width="13rem" height="2.75rem" borderRadius="8px" />
        }
    </section>

    <section class="w-full grid! grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4!">
        @for (i of [1, 2, 3, 4, 5]; track i) {
            <div class="rounded-md border border-border p-4 flex! flex-col gap-3">
                <div class="flex! justify-between items-center">
                    <p-skeleton width="2.5rem" height="2.5rem" borderRadius="8px" />
                    <p-skeleton width="2.5rem" height="1.5rem" borderRadius="999px" />
                </div>
                <p-skeleton width="80%" height="1.25rem" />
                <p-skeleton width="60%" height="1rem" />
                <p-skeleton width="5rem" height="1.5rem" borderRadius="999px" />
            </div>
        }
    </section>
}

@if (!loading()) {
    <div>
        <fb-page-header [title]="'YOUR_TRIGGERS' | translate" [subtitle]="'YOUR_TRIGGERS_SUBTITLE' | translate">
            <p-select
                actions
                class="min-w-72"
                [ngModel]="selectedClient()"
                (ngModelChange)="onSelectedClientChange($event)"
                [options]="clients()"
                optionLabel="name"
                [placeholder]="'SELECT_VENUE' | translate">
                <ng-template #selectedItem let-client>
                    <span class="flex items-center gap-2"><i class="ph ph-storefront"></i>{{ client?.name }}</span>
                </ng-template>
            </p-select>
        </fb-page-header>
    </div>

    <p-tabs class="fb-tabs" [value]="activeTab()" (valueChange)="activeTab.set($any($event))">
        <p-tablist>
            <p-tab value="automations"><i class="ph ph-lightning mr-1.5"></i>{{ 'CUSTOM_TRIGGERS' | translate }}</p-tab>
            @if (selectedClient()) {
                <p-tab value="emails"><i class="ph ph-envelope-simple mr-1.5"></i>{{ 'CUSTOMER_EMAILS' | translate }}</p-tab>
            }
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="automations">
                <p class="text-sm text-text-muted mb-6">{{ 'CUSTOM_TRIGGERS_DESC' | translate }}</p>

                @if (suggestedTriggers().birthdayEmail || suggestedTriggers().birthdaySms) {
                    <div class="mb-2 text-sm font-semibold text-text-muted uppercase tracking-wide">
                        {{ 'SUGGESTED_TRIGGERS' | translate }}
                    </div>
                    <div class="grid! grid-cols-5! gap-4! mb-8">
                        @if (suggestedTriggers().birthdayEmail) {
                            <div
                                class="flex! items-center gap-3! rounded-md border border-dashed border-border-strong hover:border-brand hover:bg-concern-accent p-4 cursor-pointer transition-all min-w-72"
                                (click)="createSuggestedBirthdayEmailTrigger()">
                                <div class="w-10 h-10 rounded-sm bg-concern-accent flex! items-center justify-center shrink-0">
                                    <i class="ph ph-cake text-concern-accent-dot text-xl"></i>
                                </div>
                                <div>
                                    <p class="font-semibold text-sm">{{ 'SUGGESTION_BIRTHDAY_EMAIL' | translate }}</p>
                                    <p class="text-xs text-text-muted">
                                        {{ 'SUGGESTION_BIRTHDAY_EMAIL_SUBTITLE' | translate }}
                                    </p>
                                </div>
                            </div>
                        }
                        @if (suggestedTriggers().birthdaySms) {
                            <div
                                class="flex! items-center gap-3! rounded-md border border-dashed border-border-strong hover:border-brand hover:bg-concern-accent p-4 cursor-pointer transition-all min-w-72"
                                (click)="createSuggestedBirthdaySmsTrigger()">
                                <div class="w-10 h-10 rounded-sm bg-concern-accent flex! items-center justify-center shrink-0">
                                    <i class="ph ph-cake text-concern-accent-dot text-xl"></i>
                                </div>
                                <div>
                                    <p class="font-semibold text-sm">{{ 'SUGGESTION_BIRTHDAY_SMS' | translate }}</p>
                                    <p class="text-xs text-text-muted">{{ 'SUGGESTION_BIRTHDAY_SMS_SUBTITLE' | translate }}</p>
                                </div>
                            </div>
                        }
                    </div>
                }

                <trigger-filters
                    [triggerTypeOptions]="triggerTypeOptions()"
                    [actionTypeOptions]="actionTypeOptions()"
                    [enabledFilterOptions]="enabledFilterOptions()"
                    [searchString]="searchString()"
                    [selectedTriggerTypes]="selectedTriggerTypes()"
                    [selectedActionTypes]="selectedActionTypes()"
                    [filterEnabled]="filterEnabled()"
                    (filtersChanged)="onFiltersChanged($event)"
                    (newTriggerClicked)="openNewTriggerDialog()"
                    [shownTriggers]="triggers().length" />

                @if (selectedClient()) {
                    @if (triggers().length > 0) {
                        <section
                            class="w-full grid! grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-4! pb-2"
                            (animate.enter)="animateStepIn($event)">
                            @for (trigger of triggers(); track trigger.id) {
                                <trigger-card
                                    (cardClicked)="openEditTriggerDialog($event)"
                                    [trigger]="trigger"
                                    (enabledChanged)="triggerChanged($event)" />
                            }
                        </section>
                    } @else {
                        <div class="flex! flex-col! items-center justify-center gap-3 py-20 text-surface-400">
                            <i class="ph ph-lightning-slash text-5xl"></i>
                            <p class="text-lg font-medium">{{ 'NO_TRIGGERS_FOUND' | translate }}</p>
                            <p class="text-sm">{{ 'NO_TRIGGERS_FOUND_SUBTITLE' | translate }}</p>
                        </div>
                    }
                }
            </p-tabpanel>
            @if (selectedClient()) {
                <p-tabpanel value="emails">
                    <booking-emails
                        [emails]="defaultEmails()"
                        [loading]="defaultEmailsLoading()"
                        [busyKind]="busyDefaultKind()"
                        [editorAvailable]="mailluneEnabled"
                        (useCustom)="useCustomEmail($event)"
                        (useDefault)="useDefaultEmail($event)"
                        (editTemplate)="openDefaultEmailEditor($event)"
                        (subjectChanged)="changeDefaultEmailSubject($event)" />
                </p-tabpanel>
            }
        </p-tabpanels>
    </p-tabs>

    @if (selectedClient(); as sigSelectedClient) {
        <placeholders-drawer
            [visible]="placeholdersVisible()"
            (visibleChange)="placeholdersVisible.set($event)"
            [dynamicOnly]="placeholdersDynamicOnly()"
            [selectedClient]="sigSelectedClient" />
    }

    <email-editor-drawer
        #emailEditorDrawerRef
        [visible]="emailEditorVisible()"
        (visibleChange)="emailEditorVisible.set($event)"
        [beefreeConfig]="beefreeConfig()"
        [mailluneConfig]="mailluneConfig()"
        [showDynamicPlaceholders]="!editingDefaultEmail()"
        (templateSaved)="emailTemplateSaved($event)"
        (cancelled)="closeEmailEditor()"
        (showPlaceholders)="showAvailablePlaceholders(mailluneEnabled)" />

    <new-trigger-dialog
        #newTriggerDialogRef
        [visible]="newTriggerDialogVisible()"
        (visibleChange)="newTriggerDialogVisible.set($event)"
        [triggerTypeOptions]="triggerTypeOptions()"
        [actionTypeOptions]="actionTypeOptions()"
        [creating]="creatingTrigger()"
        (confirmed)="confirmNewTrigger($event)" />

    <edit-trigger-dialog
        [visible]="editingTrigger()"
        (visibleChange)="editingTrigger.set($event)"
        [trigger]="editingTriggerData()!"
        [triggerTypeOptions]="triggerTypeOptions()"
        [actionTypeOptions]="actionTypeOptions()"
        [availablePackages]="availablePackages()"
        (triggerChanged)="triggerChanged($event)"
        (openEmailEditor)="openEmailEditor($event.trigger, $event.beefreeTemplate)"
        (showPlaceholders)="showAvailablePlaceholders()"
        (cancelled)="abortEditTriggerDialog()"
        (saved)="closeEditTriggerDialog($event)" />
}
